import React from "react";
import styled from "styled-components";
const StyledWrapper = styled.div`
  position: relative;
  width: 40px;
  display: flex;

  transform: translateX(${p => p.isClaimed ? "9px" : 0})
    rotate(${p => p.isClaimed ? "3deg" : 0});
`;
const StyledMain = styled.div`
  width: 30px;
  background: ${p => p.theme.colorTicketBackground};
`;
const StyledEnd = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 20px;
`;
const StyledEndBackground = styled.div`
  flex: 1 1 auto;
  background-color: ${p => p.theme.colorTicketBackground};
  border-top-right-radius: ${p => p.isTop ? p.theme.borderRadius : 0};
  border-bottom-right-radius: ${p => !p.isTop ? p.theme.borderRadius : 0}};
`;
const StyledEndPath = styled.path`
  fill: ${p => p.theme.colorTicketBackground};
`;

const Wrapper = ({
  isClaimed
}) => {
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    isClaimed: isClaimed
  }, /*#__PURE__*/React.createElement(StyledMain, null), /*#__PURE__*/React.createElement(StyledEnd, null, /*#__PURE__*/React.createElement(StyledEndBackground, {
    isTop: true
  }), /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "40",
    viewBox: "0 0 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement(StyledEndPath, {
    d: "M20 0H0V20V40H20C8.95435 40 0 31.0457 0 20C0 8.95428 8.95435 0 20 0Z"
  })), /*#__PURE__*/React.createElement(StyledEndBackground, null)));
};

export default Wrapper;